export enum NodePickerEvent {
  ADD_TEXT_BLOCK = 'addTextBlock',
  ADD_ACTION = 'addAction',
  ADD_DECISION = 'addDecision',
  ADD_CONTAINER = 'addContainer',
  ADD_SEL_BEHAVIOR = 'addSelectionBehavior',
  ADD_SUBFLOW = 'addSubflow',
}

export interface ToolbarItemConfig {
  event: NodePickerEvent;
  titleKey: string;
  descriptionKey: string;
  icon?: string;
}

export const baseToolbarItems: ToolbarItemConfig[] = [
  {
    event: NodePickerEvent.ADD_ACTION,
    titleKey: 'Flowchart.AddAction',
    descriptionKey: 'Flowchart.AddActionDescription',
    icon: '/assets/icons/flowchart-action.svg',
  },
  {
    event: NodePickerEvent.ADD_DECISION,
    titleKey: 'Flowchart.AddDecision',
    descriptionKey: 'Flowchart.AddDecisionDescription',
    icon: '/assets/icons/flowchart-decision.svg',
  },
  {
    event: NodePickerEvent.ADD_SEL_BEHAVIOR,
    titleKey: 'Flowchart.AddSelectionBehavior',
    descriptionKey: 'Flowchart.SelectionBehaviorDescription',
    icon: '/assets/icons/flowchart-operator.svg',
  },
  {
    event: NodePickerEvent.ADD_CONTAINER,
    titleKey: 'Flowchart.AddSetOfAction',
    descriptionKey: 'Flowchart.AddSetOfActionsDescription',
    icon: '/assets/icons/flowchart-container.svg',
  },
  {
    event: NodePickerEvent.ADD_TEXT_BLOCK,
    titleKey: 'Flowchart.AddTextBlock',
    descriptionKey: 'Flowchart.AddTextBlockDescription',
    icon: '/assets/icons/flowchart-text-block.svg',
  },
];

export const mainToolbarItems: ToolbarItemConfig[] = [
  ...baseToolbarItems,
  {
    event: NodePickerEvent.ADD_SUBFLOW,
    titleKey: 'Flowchart.AddSubflow',
    descriptionKey: 'Flowchart.AddSubflowDescription',
    icon: '/assets/icons/flowchart-subflow.svg',
  },
];
